import { ProjectPicker } from "@/features/projects/components/project-picker";
import { IncognitoWorkspaceProjectsPage } from "@/features/superuser/incognito/components/incognito-workspace-projects.page";
import { useWorkspaceAccess } from "@/features/workspaces/use-workspace-access";
import { WorkspaceRoute } from "@/routes/_authenticated/workspaces/$slug";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/workspaces/$slug/projects/")({
  component: ProjectsHomePage,
});

function ProjectsHomePage() {
  const { workspace } = WorkspaceRoute.useRouteContext();
  const workspaceAccess = useWorkspaceAccess();

  // CR-116 stage 3: ProjectPicker reads the caller's membership and navigates
  // into projects — neither exists for an incognito superuser.
  if (workspaceAccess.mode === "incognito") {
    return <IncognitoWorkspaceProjectsPage workspace={workspace} />;
  }

  return (
    <div className="container mx-auto max-w-3xl py-8">
      <ProjectPicker />
    </div>
  );
}
